<template>
    <v-dialog v-model="showModal" persistent :width="$vuetify.breakpoint.thresholds.sm">
        <template #activator="{ on, attrs }">
            <v-tooltip bottom>
                <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                    <v-btn icon ref="delBtn" v-on="{ ...on, ...tooltipOn }" v-bind="{ ...attrs, ...tooltipAttrs }" :disabled="!isSelected" color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('Kurs löschen') }}</span>
            </v-tooltip>
        </template>
        <DeleteConfirm
            :hasToolbar="true"
            :toolbarTitle="$t('Kurs löschen')"
            :deleteMessage="$t('Sind Sie sicher, dass Sie diesen Kurs löschen möchten?')"
            :checkboxDeleteMessage="$t('Diese Aktion kann nicht rückgängig gemacht werden.')"
            @deleteItem="deleteCourse"
            @closeEmit="close"
        />
    </v-dialog>
</template>
<script>
import CourseMixin from './Mixins/CourseMixin';
import DeleteConfirm from '../../Generic/DeleteConfirm';

export default {
    name: 'delete-course',
    mixins: [CourseMixin],
    data: () => ({
        showModal: false
    }),
    components: {
        DeleteConfirm
    },
    computed: {
        isSelected() {
            return Object.keys(this.getSelectedAdminCourse).length > 0;
        }
    },
    methods: {
        close() {
            this.showModal = false;
            this.$nextTick(() => {
                this.$refs.delBtn.$el.blur();
            });
        },
        deleteCourse() {
            this.DELETE_COURSE(this.getSelectedAdminCourse).then(() => this.close());
        }
    }
};
</script>
